var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fs5-estimated-earns-card"},[_c('div',{staticClass:"fs5-earns-card-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"fs5-earns-card-value",domProps:{"innerHTML":_vm._s(_vm.value)}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673b5ad8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/office/js/components/franchise_v5/tools/card/EstimatedEarnsCard.vue
// module id = Ncar
// module chunks = 0